/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import * as selectors from "../../selectors";
import * as pageSelectors from "../../selectors/page";
import * as pageActions from "../../actions/page";
import LoadingIndicator from "../../components/LoadingIndicator";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  overflow-y: scroll;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledDescriptionContentContainer = styled.div`
  self-align: stretch;
  padding: 15px;
  text-align: start;
  line-height: 1.3em;
  font-size: 0.9em;
`;

class TermsAndConditionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationClass: null
    };
  }

  componentDidMount() {
    this.configureNavBar();
    this.setState({ animationClass: "slide-in-right" });
    this.fetchPageTncData();
  }

  fetchPageTncData = () => {
    const { getPageTncDataRequest } = this.props;

    getPageTncDataRequest();
  };

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <FormattedMessage
        id="profile.term.and.condition"
        defaultMessage="Terms And Conditions"
      />
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed());
    showNavbar(true);
    showTabbar(false);
  };

  getLoadingIndicator = () => {
    const { tncLoading } = this.props;

    return tncLoading ? <LoadingIndicator /> : false;
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  render() {
    const { animationClass } = this.state;
    const { tncData } = this.props;
    const htmlContent = pageSelectors.getPageTncItemContent(tncData);

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        <StyledDescriptionContentContainer
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </StyledContainer>
    );
  }
}

TermsAndConditionsPage.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  tncData: PropTypes.object,
  tncLoading: PropTypes.bool,
  getPageTncDataRequest: PropTypes.func
};

function mapStateToProps(state) {
  return {
    tncData: selectors.getPageTncDataItem(state),
    tncLoading: selectors.getPageTncDataLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPageTncDataRequest: () => dispatch(pageActions.getPageTncDataRequest())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsAndConditionsPage);



// WEBPACK FOOTER //
// ./src/containers/TermsAndConditionsPage/index.js